import { nanoid } from "nanoid";
import { ValidationService } from "../../services/validation.service";
import { Coordinate } from "../coordinate.model";

export class SpeciesAtRiskReport {

  encounterDate: Date = new Date();

  internalId: string = '';

  reportId: string = '';

  latitude!: Coordinate;

  longitude!: Coordinate;

  species: string = '';

  speciesCode: number = 0;

  numSpecimens: number | undefined; //must not be initialized as per spec sheet

  weight: number | undefined; //optional

  condition: string = '';

  conditionCode: number = 0;

  comments: string = ''; // optional

  /* Flags for programmatical use */

  isComplete: boolean = false;

  isSubmitted: boolean = false; // flag that tells us if the report has been sent to DFO

  constructor() {
    this.internalId = 'id-' + nanoid();
  }

  public isValid(): boolean {
    return this.isComplete;
  }

  public toString(): string {
    return 'Encounter Date: ' + this.encounterDate;
  }


  // check if the user's Species At Risk Reports are defined
  public static transformAnonymous(speciesAtRiskReports: any): SpeciesAtRiskReport[] {

    // if it is not defined, set a new one
    if (!speciesAtRiskReports) {
      return [];
    }

    let userSpeciesAtRiskReports: SpeciesAtRiskReport[] = [];
    for (let speciesAtRiskReport of speciesAtRiskReports) {
      let userSpeciesAtRiskReport: SpeciesAtRiskReport = new SpeciesAtRiskReport();
      userSpeciesAtRiskReport.internalId = speciesAtRiskReport.internalId;
      userSpeciesAtRiskReport.encounterDate = ValidationService.validateDate(speciesAtRiskReport.encounterDate);
      userSpeciesAtRiskReport.latitude = Coordinate.transformAnon(speciesAtRiskReport.latitude);
      userSpeciesAtRiskReport.longitude = Coordinate.transformAnon(speciesAtRiskReport.longitude);
      userSpeciesAtRiskReport.species = speciesAtRiskReport.species;
      userSpeciesAtRiskReport.numSpecimens = speciesAtRiskReport.numSpecimens;
      userSpeciesAtRiskReport.weight = speciesAtRiskReport.weight ?? '';
      userSpeciesAtRiskReport.condition = speciesAtRiskReport.condition;
      userSpeciesAtRiskReport.comments = speciesAtRiskReport.comments ?? '';
      userSpeciesAtRiskReport.reportId = speciesAtRiskReport.reportId;
      userSpeciesAtRiskReport.isSubmitted = speciesAtRiskReport.isSubmitted ?? false;
      userSpeciesAtRiskReports.push(userSpeciesAtRiskReport);
    }
    return userSpeciesAtRiskReports;

  }

}
